import { render, staticRenderFns } from "./Proper.vue?vue&type=template&id=25fba4eb&scoped=true&"
import script from "./Proper.vue?vue&type=script&lang=js&"
export * from "./Proper.vue?vue&type=script&lang=js&"
import style0 from "./Proper.vue?vue&type=style&index=0&id=25fba4eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fba4eb",
  null
  
)

export default component.exports